import { render, staticRenderFns } from "./IMPlaceHierarchy.vue?vue&type=template&id=118715b5&"
import script from "./IMPlaceHierarchy.vue?vue&type=script&lang=js&"
export * from "./IMPlaceHierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports